<dv-radio-group
  [direction]="radioGroupItemsDirection"
  labelKey="label"
  valueKey="value"
  [value]="value()"
  (valueChange)="onValueChange($event)"
  [gridSize]="4"
  [items]="items">
</dv-radio-group>
